// utils/resumeDataUtils.ts
interface Experience {
  date: string;
  role: string;
  organisation: string;
}
const createExperienceElement = (item: Experience | null): HTMLElement => {
  const div = document.createElement("div");
  div.classList.add("section-item", "p-relative");

  const div2 = document.createElement("div");
  div2.classList.add("head-ball");

  const small = document.createElement("small");
  small.classList.add("gray");
  small.textContent = item?.date ?? "N/A";

  const h3 = document.createElement("h3");
  h3.classList.add("secondary-color", "bold");
  h3.textContent = item?.organisation ?? "N/A";

  const p = document.createElement("p");
  p.textContent = item?.role ?? "N/A";

  div.append(div2, small, h3, p);
  return div;
};

export const get_Experience = (experienceData: Experience[]) => {
  const experienceElement = document.getElementById("experienceItem");
  if (!experienceElement) return;

  // Clear previous content to prevent duplicates
  experienceElement.innerHTML = "";
  
  if (!Array.isArray(experienceData) || experienceData.length === 0) {
    experienceElement.appendChild(createExperienceElement(null));
    return;
  }

  experienceData.forEach((item) => {
    const experienceNode = createExperienceElement(item);
    experienceElement.appendChild(experienceNode);
  });
};


interface Education {
  date: string;
  schoolName: string;
  qualification: string;
}
const createEducationElement = (item: Education | null): HTMLElement => {
  const div = document.createElement("div");
  div.classList.add("section-item");
  div.classList.add("p-relative");

  const div2 = document.createElement("div");
  div2.classList.add("head-ball");

  const small = document.createElement("small");
  small.classList.add("gray");
  small.textContent = item?.date || "N/A";

  const h3 = document.createElement("h3");
  h3.classList.add("secondary-color");
  h3.classList.add("bold");
  h3.textContent = item?.schoolName || "N/A";

  const p = document.createElement("p");
  p.textContent = item?.qualification || "N/A";

  div.append(div2, small, h3, p);

  return div;
};

export const get_Education = (eduData: unknown) => {
  const educationElement = document.getElementById("educationItem");
  if (!educationElement) return;

  // Clear previous content to prevent duplicates
  educationElement.innerHTML = "";

  if (!Array.isArray(eduData) || eduData.length === 0) {
    educationElement.appendChild(createEducationElement(null));
    return;
  }

  eduData.forEach((item) => {
    const educationNode = createEducationElement(item);
    educationElement.appendChild(educationNode);
  });
};

interface Skill {
  skill: string;
  rating: number;
}

// Helper function to create a single skill item with stars
const createSkillElement = (item: Skill | null): HTMLElement => {
  const div = document.createElement("div");
  div.classList.add("skill-item");

  const h3 = document.createElement("h3");
  h3.textContent = item?.skill ?? "N/A";
  div.append(h3);

//   Enable keyboard event (This was commented out due to it listened while not on focus)
//   const maxStars = 5;
//   let rating = item?.rating ?? maxStars;

//   if (typeof rating !== "number" || rating < 0 || rating > maxStars) {
//     rating = maxStars;
//   }

//   const filledStars = Math.floor(rating);
//   const emptyStars = maxStars - filledStars;

//   for (let i = 0; i < filledStars; i++) {
//     const star = document.createElement("i");
//     star.classList.add("fas", "fa-star", "secondary-color");
//     div.append(star);
//   }

//   for (let i = 0; i < emptyStars; i++) {
//     const star = document.createElement("i");
//     star.classList.add("fas", "fa-star");
//     div.append(star);
//   }

  return div;
};

export const get_Skill = (skillData: Skill[]) => {
  const skillElement = document.getElementById("skillData");
  if (!skillElement) return;

  skillElement.innerHTML = ""; // Clear previous content

  if (!Array.isArray(skillData) || skillData.length === 0) {
    skillElement.appendChild(createSkillElement(null));
    return;
  }

  skillData.forEach((item) => {
    const skillNode = createSkillElement(item);
    skillElement.appendChild(skillNode);
  });
};

interface Certificate {
  title: string;
  organisation: string;
  url: string | null;
  certType: number;
}

const createCertificateElement = (item: Certificate | null): HTMLElement => {
  const div = document.createElement("div");
  div.classList.add("section-item", "p-relative");

  const div2 = document.createElement("div");
  div2.classList.add("head-ball");

  const div3 = document.createElement("div");
  div3.classList.add("separate");

  const small = document.createElement("small");
  small.classList.add("gray");
  small.textContent = item?.title ?? "N/A";

  const h3 = document.createElement("h3");
  h3.classList.add("secondary-color", "bold");
  h3.textContent = item?.organisation ?? "N/A";

  const i = document.createElement("i");
  i.classList.add("primary-color", "fas");
  if (item?.certType === 1) i.classList.add("fa-award");
  else if (item?.certType === 2) i.classList.add("fa-trophy");

  div3.append(i, h3);

  const a = document.createElement("a");
  if (item?.url) {
    a.href = `http://${item.url}`;
    a.target = "_blank";
    a.title = item.organisation;
    a.textContent = item.url;
  } else {
    a.href = "#";
    a.title = "No link provided";
    a.classList.add("gray");
    a.textContent = "N/A";
  }

  div.append(div2, small, div3, a);
  return div;
};

export const get_Certificate = (certData: unknown) => {
  const certElement = document.getElementById("certificateItem");
  
  if (!certElement) {
    console.warn("certification-items element not found.");
    return;
  }

  // Clear previous content to prevent duplicates
  certElement.innerHTML = "";

  if (!Array.isArray(certData)) {
    console.log("Input args is not an array of objects");
    const fallbackElement = createCertificateElement(null);
    certElement.appendChild(fallbackElement);
    return;
  }

  certData.forEach((item) => {
    const certItem = createCertificateElement(item as Certificate);
    certElement.appendChild(certItem);
  });
};

interface QA {
  question: string;
  answer: string;
}

const createQAElement = (item: QA | null): HTMLElement => {
  const div = document.createElement("div");

  const button = document.createElement("button");
  button.classList.add("collapsible");
  button.textContent = item?.question ?? "N/A";

  const innerDiv = document.createElement("div");
  innerDiv.classList.add("content-collapse");

  const p = document.createElement("p");
  p.classList.add('fs-18');
  p.textContent = item?.answer ?? "N/A";

  innerDiv.appendChild(p);
  div.appendChild(button);
  div.appendChild(innerDiv);

  return div;
};

export const get_QA = (qaData: unknown) => {
  const qaElement = document.getElementById("qa-content");
  if (!qaElement) {
    console.warn("qa-content element not found.");
    return;
  }

  qaElement.textContent = "";

  if (!Array.isArray(qaData)) {
    console.log("Input args is not an array");
    const fallback = createQAElement(null);
    qaElement.appendChild(fallback);
    return;
  }

  qaData.forEach((item) => {
    const qaItem = createQAElement(item as QA);
    qaElement.appendChild(qaItem);
  });
};
